module.exports = __webpack_public_path__ + "img/cart.8ba212a7.svg";